// extracted by mini-css-extract-plugin
export default {"fullWidth":"tn-z","image":"un-z","lazyLoadPicture":"vn-z","lazyLoadSpinner":"wn-z","lazyLoadSpin":"xn-z","lazyLoadImage":"yn-z","hasStyledAspectRatio":"zn-z"};